import { useQuery } from '@tanstack/react-query'
import { useTypedApiClient } from 'hooks/useTypedApiClient'
import { type ContestType } from 'types/api'

export const useGetSweepstakesByTypeWithGrouping = ({
  type,
}: {
  type: ContestType
}) => {
  const get = useTypedApiClient({
    path: '/admin/contests/typeWithGrouping/{contestType}',
    method: 'get',
  })

  return useQuery({
    queryKey: ['/sweepstakes'],
    queryFn: async () => {
      const { data } = await get({ contestType: type })
      return data
    },
  })
}
